import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/promise';
import 'core-js/es/symbol';
import 'core-js/es/reflect';
import 'core-js/es/string';
import 'core-js/es/object';
